import {
  Badge,
  Button,
  Card,
  Layout,
  TextContainer,
  TextStyle,
} from "@shopify/polaris";
import React from "react";

const ImportDetails = ({ importHistory, onRollback }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleString();
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return "-";
    const sizes = ["Bytes", "KB", "MB", "GB"];
    if (bytes === 0) return "0 Bytes";
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round((bytes / Math.pow(1024, i)) * 100) / 100 + " " + sizes[i];
  };

  const getStatusTone = (status) => {
    const statusConfig = {
      completed: "success",
      failed: "critical",
      processing: "warning",
      pending: "subdued",
      rolled_back: "info",
    };
    return statusConfig[status] || "subdued";
  };

  return (
    <div>
      <Layout>
        <Layout.Section twoThirds>
          <Card title="Import Details">
            <Card.Section>
              <Layout>
                <Layout.Section oneHalf>
                  <TextContainer>
                    <div style={{ marginBottom: "1rem" }}>
                      <TextStyle variation="strong">File:</TextStyle>{" "}
                      {importHistory.filename}
                    </div>
                    <div style={{ marginBottom: "1rem" }}>
                      <TextStyle variation="strong">Status:</TextStyle>
                      <Badge
                        status={getStatusTone(importHistory.status)}
                        style={{ marginLeft: "0.5rem" }}
                      >
                        {importHistory.status}
                      </Badge>
                    </div>
                    <div style={{ marginBottom: "1rem" }}>
                      <TextStyle variation="strong">Started:</TextStyle>{" "}
                      {formatDate(importHistory.started_at)}
                    </div>
                    {importHistory.gcp_file_id && (
                      <div style={{ marginBottom: "1rem" }}>
                        <TextStyle variation="strong">GCP ID:</TextStyle>{" "}
                        <code>{importHistory.gcp_file_id}</code>
                      </div>
                    )}
                    {importHistory.file_checksum && (
                      <div style={{ marginBottom: "1rem" }}>
                        <TextStyle variation="strong">Checksum:</TextStyle>{" "}
                        <code style={{ fontSize: "0.8em" }}>{importHistory.file_checksum}</code>
                        {importHistory.skipped_duplicate && (
                          <Badge status="info" style={{ marginLeft: "0.5rem" }}>
                            Duplicate
                          </Badge>
                        )}
                      </div>
                    )}
                    <div style={{ marginBottom: "1rem" }}>
                      <TextStyle variation="strong">Completed:</TextStyle>{" "}
                      {formatDate(importHistory.completed_at)}
                    </div>
                    <div style={{ marginBottom: "1rem" }}>
                      <TextStyle variation="strong">Duration:</TextStyle>{" "}
                      {importHistory.duration_formatted}
                    </div>
                  </TextContainer>
                </Layout.Section>
                <Layout.Section oneHalf>
                  <TextContainer>
                    <div style={{ marginBottom: "1rem" }}>
                      <TextStyle variation="strong">File Size:</TextStyle>{" "}
                      {formatFileSize(importHistory.file_size)}
                    </div>
                    <div style={{ marginBottom: "1rem" }}>
                      <TextStyle variation="strong">Import Type:</TextStyle>{" "}
                      {importHistory.import_type}
                    </div>
                    <div style={{ marginBottom: "1rem" }}>
                      <TextStyle variation="strong">
                        Variant Grouping:
                      </TextStyle>{" "}
                      {importHistory.use_variant_grouping ? "Yes" : "No"}
                    </div>
                    <div style={{ marginBottom: "1rem" }}>
                      <TextStyle variation="strong">Can Rollback:</TextStyle>{" "}
                      {importHistory.can_rollback ? "Yes" : "No"}
                    </div>
                    {importHistory.rolled_back_at && (
                      <div style={{ marginBottom: "1rem" }}>
                        <TextStyle variation="strong">Rolled Back:</TextStyle>{" "}
                        {formatDate(importHistory.rolled_back_at)}
                        {importHistory.rolled_back_by && (
                          <span> by {importHistory.rolled_back_by}</span>
                        )}
                      </div>
                    )}
                  </TextContainer>
                </Layout.Section>
              </Layout>
            </Card.Section>
          </Card>
        </Layout.Section>
        <Layout.Section oneThird>
          <Card title="Summary">
            <Card.Section>
              <TextContainer>
                <div style={{ marginBottom: "1rem" }}>
                  <TextStyle variation="strong">Total Processed:</TextStyle>{" "}
                  {importHistory.total_products_processed}
                </div>
                <div style={{ marginBottom: "1rem" }}>
                  <TextStyle variation="strong">Created:</TextStyle>{" "}
                  {importHistory.products_created}
                </div>
                <div style={{ marginBottom: "1rem" }}>
                  <TextStyle variation="strong">Updated:</TextStyle>{" "}
                  {importHistory.products_updated}
                </div>
                <div style={{ marginBottom: "1rem" }}>
                  <TextStyle variation="strong">Unchanged:</TextStyle>{" "}
                  {importHistory.products_unchanged}
                </div>
                {importHistory.products_skipped > 0 && (
                  <div style={{ marginBottom: "1rem" }}>
                    <TextStyle variation="strong">Skipped:</TextStyle>{" "}
                    <span style={{ color: "#6366f1" }}>{importHistory.products_skipped}</span>
                  </div>
                )}
                <div style={{ marginBottom: "1rem" }}>
                  <TextStyle variation="strong">Failed:</TextStyle>{" "}
                  {importHistory.products_failed}
                </div>
                {importHistory.error_count > 0 && (
                  <div style={{ marginBottom: "1rem" }}>
                    <TextStyle variation="strong">Errors:</TextStyle>{" "}
                    {importHistory.error_count}
                  </div>
                )}
                {importHistory.can_rollback && (
                  <Button tone="critical" fullWidth onClick={onRollback}>
                    Rollback Import
                  </Button>
                )}
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.Section>
      </Layout>

      {importHistory.notes && (
        <Layout.Section>
          <Card title="Notes">
            <Card.Section>
              <TextContainer>
                <p>{importHistory.notes}</p>
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.Section>
      )}
    </div>
  );
};

export default ImportDetails;
